import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { RemoveCartLineApiParameter, removeCartLineWithResult as removeCartLineApi } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartLineIds: string | string[]; // Accept single or multiple cartLineIds
    },
    RemoveCartLineApiParameter
>;

export const DispatchBeginRemoveCartLine: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
    const cartLineIds = Array.isArray(props.parameter.cartLineIds) ? props.parameter.cartLineIds : [props.parameter.cartLineIds];
    cartLineIds.forEach(cartLineId =>
        props.dispatch({
            type: "Pages/Cart/BeginRemoveCartLine",
            cartLineId,
        }),
    );
};

export const RemoveCartLine: HandlerType = async props => {
    const cartLineIds = Array.isArray(props.parameter.cartLineIds) ? props.parameter.cartLineIds : [props.parameter.cartLineIds];

    for (const cartLineId of cartLineIds) {
        const apiParameter: RemoveCartLineApiParameter = {
            cartLineId,
            cartId: API_URL_CURRENT_FRAGMENT,
        };
        await removeCartLineApi(apiParameter);
    }
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart({ getPromotions: true, getCartLines: true }));
};

/** @deprecated Not needed anymore */
export const LoadPromotions: HandlerType = () => {};

export const DispatchCompleteRemoveCartLine: HandlerType = props => {
    const cartLineIds = Array.isArray(props.parameter.cartLineIds) ? props.parameter.cartLineIds : [props.parameter.cartLineIds];
    cartLineIds.forEach(cartLineId =>
        props.dispatch({
            type: "Pages/Cart/CompleteRemoveCartLine",
            cartLineId,
        }),
    );
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
    props.dispatch({
        type: "Data/OrderApprovals/Reset",
    });
};

export const chain = [DispatchBeginRemoveCartLine, RemoveCartLine, LoadCart, LoadPromotions, DispatchCompleteRemoveCartLine];

const removeCartLine = createHandlerChainRunner(chain, "RemoveCartLine");
export default removeCartLine;
